module.exports = __webpack_public_path__ + "static/media/WellDoneIcon.9a13e60f.png";